import React, { Component } from 'react';
import {Modal,ModalBody,Button} from 'reactstrap';
import InfoMessage from '../../../../components/Message/InfoMessage/InfoMessage';
import './ToolDetails.css';
import {staticTitles} from '../../../../utils/constants';



let restoreMsg=`You can restore an archived ${staticTitles.toolkit_sm} by going to the ${staticTitles.toolkit_lg} “Archive” page.`
class ArchiveModal extends Component {
  state = {  }


  checkForEa =(toolDetails, currentUser)=>{
    let userCheck = currentUser && currentUser._id && toolDetails && toolDetails.createdBy
    // console.log('current-', currentUser)
    if(userCheck && (currentUser._id !== toolDetails.createdBy._id && currentUser.orgAdmin)) {
      return true
    } else {
      return false
    }
  }

  render() { 
    const {showModal, currentUser, toolDetails} = this.props;

    return ( 
      <div>
        <Modal 
          isOpen={showModal}>
          <ModalBody style={{padding:'30px 0px'}}>
            <div className="row">
              <div className="offset-md-1 offset-lg-1 col-sm-10 col-md-10 pick-office-modal-body-title">
                Archive {staticTitles.toolkit_lg}
              </div>
            </div>
            <div className="row mt10">
              <div className="offset-md-1 offset-lg-1 col-sm-10 col-md-10 col-md-offset-right-1 archive-modal-msg">
                You are about to archive a {staticTitles.toolkit_sm}. Once archived, it will be removed from the {staticTitles.toolkit_lg} category pages for all users who 
                have access to it.

                { this.checkForEa(toolDetails, currentUser)?
                   <p>
                     <br/>The creator of this resource will be notified that it has been archived.
                   </p>
                :
                null
              }
              </div>
             
            </div>

            <div className="row mt10">
                <div className="offset-md-1 col-sm-10 col-md-10">
                <InfoMessage iconLeft='' msg="Important Note." subMsg={restoreMsg} /></div>
            </div>
            <div className="row mt30">
              <div className="offset-md-1 col-sm-3 col-md-3">
                <Button 
                  onClick={this.props.archiveTool}
                  className="float-right archiveBtn w100"
                >
                  <span className="archiveBtnTxt">Archive {staticTitles.toolkit_lg}</span>
                </Button>
              </div>
              <div className="col-sm-3 col-md-3">
                <Button
                  className="float-left goBackBtn w100"
                  onClick={this.props.toggle}
                >
                  <span className="goBackBtnTxt">Cancel</span>
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}
 
export default ArchiveModal;